export enum InfrastructureOptions {
    UNKNOWN = 0,
    CLOSED_AREA = 1,
    CONCIERGE = 2,
}
